document.addEventListener('DOMContentLoaded', function () {
  const root = document.getElementById('recon-calc-v3');
  if (!root) return;

  const elMg = document.getElementById('rc3-mg');
  const elVol = document.getElementById('rc3-vol');
  const elDose = document.getElementById('rc3-dose');
  const elDoseUnit = document.getElementById('rc3-dose-unit');
  const elUnitsPerMl = document.getElementById('rc3-units-per-ml');
  const elRound = document.getElementById('rc3-round');

  const outTotalMcg = document.getElementById('rc3-total-mcg');
  const outConc = document.getElementById('rc3-conc');
  const outMcgPer10u = document.getElementById('rc3-mcg-per-10u');
  const outUnitsDraw = document.getElementById('rc3-units-draw');
  const outMlDraw = document.getElementById('rc3-ml-draw');
  const outLine = document.getElementById('rc3-line');

  const warnBox = document.getElementById('rc3-warn');
  const hardWarn = document.getElementById('rc3-embed-warn');
  const btnCopy = document.getElementById('rc3-copy');
  const copied = document.getElementById('rc3-copied');

  const required = [elMg, elVol, elDose, elDoseUnit, elUnitsPerMl, elRound,
    outTotalMcg, outConc, outMcgPer10u, outUnitsDraw, outMlDraw, outLine,
    warnBox, hardWarn, btnCopy, copied];

  if (required.some(x => !x)) {
    console.warn('Reconstitution calculator missing elements (HTML edited or duplicated IDs).');
    hardWarn.style.display = 'block';
    hardWarn.textContent = 'Calculator error: missing elements. Ensure the full HTML block is present on this page.';
    btnCopy.disabled = true;
    return;
  }

  function isPos(n){ return Number.isFinite(n) && n > 0; }
  function toMcg(val, unit){ return isPos(val) ? (unit === 'mg' ? val * 1000 : val) : NaN; }
  function roundUnits(value, step){
    if (step === 'none') return value;
    const s = parseFloat(step);
    if (!Number.isFinite(s) || s <= 0) return value;
    return Math.round(value / s) * s;
  }
  function fmt(n, digits=2){
    if (!Number.isFinite(n)) return '—';
    return n.toLocaleString(undefined, { maximumFractionDigits: digits });
  }
  function setCopyEnabled(enabled){
    btnCopy.disabled = !enabled;
    btnCopy.style.opacity = enabled ? '1' : '0.55';
    btnCopy.style.cursor = enabled ? 'pointer' : 'not-allowed';
  }

  function recalc(){
    copied.textContent = '';

    const mg = parseFloat(elMg.value);
    const volMl = parseFloat(elVol.value);
    const doseVal = parseFloat(elDose.value);
    const doseUnit = elDoseUnit.value;
    const unitsPerMl = parseFloat(elUnitsPerMl.value);

    const totalMcg = isPos(mg) ? mg * 1000 : NaN;
    const doseMcg = toMcg(doseVal, doseUnit);

    const mcgPerMl = (isPos(totalMcg) && isPos(volMl)) ? (totalMcg / volMl) : NaN;
    const mlPerUnit = isPos(unitsPerMl) ? (1 / unitsPerMl) : NaN;

    const mcgPerUnit = (isPos(mcgPerMl) && isPos(mlPerUnit)) ? (mcgPerMl * mlPerUnit) : NaN;
    const mcgPer10u = Number.isFinite(mcgPerUnit) ? mcgPerUnit * 10 : NaN;

    const unitsRaw = (isPos(doseMcg) && isPos(mcgPerUnit)) ? (doseMcg / mcgPerUnit) : NaN;
    const unitsRounded = Number.isFinite(unitsRaw) ? roundUnits(unitsRaw, elRound.value) : NaN;
    const mlDraw = (isPos(unitsRounded) && isPos(mlPerUnit)) ? (unitsRounded * mlPerUnit) : NaN;

    outTotalMcg.textContent = Number.isFinite(totalMcg) ? `${fmt(totalMcg,0)} mcg` : '—';
    outConc.textContent = Number.isFinite(mcgPerMl) ? `${fmt(mcgPerMl,2)} mcg/mL` : '—';
    outMcgPer10u.textContent = Number.isFinite(mcgPer10u) ? `${fmt(mcgPer10u,0)} mcg / 10u` : '—';
    outUnitsDraw.textContent = Number.isFinite(unitsRaw) ? `${fmt(unitsRounded,2)} units` + (elRound.value !== 'none' ? ' (rounded)' : '') : '—';
    outMlDraw.textContent = Number.isFinite(mlDraw) ? `${fmt(mlDraw,3)} mL` : '—';

    const warnings = [];
    if (Number.isFinite(unitsRaw)) {
      if (unitsRaw < 1) warnings.push('Very small draw (<1 unit). Consider adding more mL to reduce measurement error.');
      if (unitsRaw < 5) warnings.push('Small draw (<5 units). Measurement error risk is higher.');
      if (isPos(unitsPerMl) && unitsRaw > unitsPerMl) warnings.push(`Dose exceeds ${fmt(unitsPerMl,0)} units (1 mL). Consider higher concentration or split draws.`);
    }
    if (Number.isFinite(volMl)) {
      if (volMl < 0.5) warnings.push('Very low total volume (<0.5 mL). Handling error risk is higher.');
      if (volMl > 5) warnings.push('Very high total volume (>5 mL). Consider a smaller reconstitution volume.');
    }
    if (Number.isFinite(mcgPerUnit) && mcgPerUnit > 100) {
      warnings.push('High mcg per unit (>100). Consider lowering concentration to reduce dosing error.');
    }

    warnBox.style.display = warnings.length ? 'block' : 'none';
    warnBox.textContent = warnings.join(' ');

    const hasResult = Number.isFinite(totalMcg) && Number.isFinite(volMl) && Number.isFinite(doseMcg) && Number.isFinite(unitsRaw);
    if (hasResult) {
      outLine.textContent =
        `Vial: ${fmt(mg,3)} mg (${fmt(totalMcg,0)} mcg) | Added: ${fmt(volMl,3)} mL | ` +
        `Conc: ${fmt(mcgPerMl,2)} mcg/mL | Dose: ${fmt(doseMcg,2)} mcg = ${fmt(unitsRounded,2)}u (${fmt(mlDraw,3)} mL) | ` +
        `10u=${fmt(mcgPer10u,0)} mcg`;
      setCopyEnabled(true);
    } else {
      outLine.textContent = '—';
      setCopyEnabled(false);
    }
  }

  [elMg, elVol, elDose, elDoseUnit, elUnitsPerMl, elRound].forEach(el => {
    el.addEventListener('input', recalc);
    el.addEventListener('change', recalc);
  });

  btnCopy.addEventListener('click', async () => {
    const text = outLine.textContent;
    if (!text || text === '—') return;
    try {
      await navigator.clipboard.writeText(text);
      copied.textContent = 'Copied.';
    } catch (e) {
      const ta = document.createElement('textarea');
      ta.value = text;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      copied.textContent = 'Copied.';
    }
  });

  recalc();
});
